<template>
  <div class="container">
    <div class="mwow-detail-header">
      <div class="left">
        <div class="back-btn" @click="$router.go(-1)">
          <i class="el-icon-arrow-left"></i>
          <span>返回</span>
        </div>
      </div>
      <div class="mid">
        <p>课程详情</p>
      </div>
      <div class="right"></div>
    </div>
    <el-form
      size="mini"
      :model="addCourseForm"
      label-width="88px"
      ref="mainForm"
      :rules="rules"
    >
      <div class="block">
        <p class="title">
          基本信息<span class="tips">科目设置中，可添加自定义科目</span>
        </p>
        <el-form-item label="科目:" prop="subject_id" d>
          <el-select
            v-model="addCourseForm.subject_id"
            placeholder="请选择"
            @change="handleSubjectChange"
            :disabled="form_disabled"
          >
            <el-option
              v-for="item in allSubjectList"
              :key="item.subject_id"
              :label="item.subject_title"
              :value="item.subject_id"
            >
            </el-option>
          </el-select>
          <subject-dialog @change="getSubjectList"></subject-dialog>
        </el-form-item>
        <el-form-item label="课程名称:" prop="course_name" style="width: 50%">
          <el-input
            v-model="addCourseForm.course_name"
            placeholder="请输入"
            maxlength="30"
          ></el-input>
        </el-form-item>
        <el-form-item label="课程类型:" prop="course_type">
          <div v-if="$route.query.id !== '0'">
            <div
              v-if="addCourseForm.course_type === 1"
              class="mwow-button-filled success"
            >
              1vN
            </div>
            <div
              v-if="addCourseForm.course_type === 2"
              class="mwow-button-filled success"
            >
              1v1
            </div>
          </div>
          <el-radio-group v-model="addCourseForm.course_type" v-else>
            <el-radio-button :label="1">1vN</el-radio-button>
            <el-radio-button :label="2">1v1</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="课包类型:"
          prop="package_type"
          v-if="coursePackageSwitch === 1"
        >
          <div v-if="$route.query.id !== '0'">
            <div
              v-if="addCourseForm.package_type === 1"
              class="mwow-button-filled success"
            >
              普通课包
            </div>
            <div
              v-if="addCourseForm.package_type === 2"
              class="mwow-button-filled success"
            >
              时间课包
            </div>
          </div>
          <el-radio-group
            v-model="addCourseForm.package_type"
            v-else
            @change="
              () => {
                if (addCourseForm.package_type === 2) {
                  addCourseForm.absent_rule = 1;
                  addCourseForm.leave_rule = 1;
                }
              }
            "
          >
            <el-radio-button :label="1">普通课包</el-radio-button>
            <el-radio-button :label="2">时间课包</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="课程颜色:" prop="color">
          <div style="visibility: hidden; height: 0px; overflow: hidden">
            <el-input v-model="addCourseForm.color"></el-input>
          </div>
          <color-selector
            :originColor.sync="addCourseForm.color"
          ></color-selector>
        </el-form-item>
      </div>
      <div class="block">
        <p class="title">
          费用信息<span class="tips"
            >为方便灵活购买，请保留课时数量为1的单位价格</span
          >
        </p>
        <el-form-item label="售卖方式:" prop="sell_type">
          <el-radio-group v-model="addCourseForm.sell_type">
            <el-radio :label="2">课包</el-radio>
            <el-radio :label="1">自定义</el-radio>
          </el-radio-group>
          <span
            class="mwow-yellow"
            v-show="addCourseForm.sell_type === 1"
            style="font-size: 14px; margin-left: 36px"
          >
            课程售卖方式指定为“自定义”，将自动删除课包关联关系！
          </span>
          <span
            class="mwow-yellow"
            v-show="addCourseForm.sell_type === 2"
            style="font-size: 14px; margin-left: 36px"
          >
            课程售卖方式指定为“课包”，将自动与课包关联！
          </span>
        </el-form-item>
        <div class="course-package-wrap" v-if="addCourseForm.sell_type === 2">
          <div class="no-data" v-if="coursePackageList.length === 0">
            暂未关联课包
          </div>
          <el-table
            v-else
            size="mini"
            :data="coursePackageList"
            stripe
            style="width: 100%"
            tooltip-effect="dark"
            class="mwow-table micro"
          >
            <el-table-column prop="name" label="课包名称"></el-table-column>
            <el-table-column prop="quantity" label="课时数"></el-table-column>
            <el-table-column label="单价">
              <template slot-scope="scope">
                <span v-show="addCourseForm.course_type === 1">{{
                  scope.row.unit_price_1vn
                }}</span>
                <span v-show="addCourseForm.course_type === 2">{{
                  scope.row.unit_price_1v1
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="总价">
              <template slot-scope="scope">
                <span v-show="addCourseForm.course_type === 1">{{
                  scope.row.price_1vn
                }}</span>
                <span v-show="addCourseForm.course_type === 2">{{
                  scope.row.price_1v1
                }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-form-item
          label="课时定价:"
          prop="course_spec"
          v-if="addCourseForm.sell_type === 1"
        >
          <price-table
            :originData="addCourseForm.course_spec"
            :courseId="addCourseForm.course_id"
            ref="priceTable"
          ></price-table>
        </el-form-item>
        <el-form-item label="扣课规则:" prop="leave_rule">
          <el-form-item
            label="请假是否扣课:"
            style="margin-bottom: 12px"
            label-width="110"
          >
            <el-radio-group
              v-model="addCourseForm.leave_rule"
              :disabled="addCourseForm.package_type === 2"
            >
              <el-radio-button :label="1">扣</el-radio-button>
              <el-radio-button :label="0">不扣</el-radio-button>
              <el-radio-button :label="2">部分扣</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <div class="leave-cost-wrap" v-if="addCourseForm.leave_rule === 2">
            <p class="tips">如设置“每月前5次请假不扣课时”，超出范围会扣除</p>
            <el-form-item label=" " prop="leave_cycle" label-width="0">
              <el-select v-model="addCourseForm.leave_cycle">
                <el-option label="不限时间" :value="0"></el-option>
                <el-option label="每月" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <span class="text">前</span>
            <el-form-item label=" " prop="leave_number" label-width="0">
              <el-input
                v-model.number="addCourseForm.leave_number"
                placeholder="请输入次数"
                type="number"
              ></el-input>
            </el-form-item>
            <span class="text">次不扣</span>
          </div>
          <el-form-item
            label="未到是否扣课:"
            prop="absent_rule"
            label-width="110"
          >
            <el-radio-group
              v-model="addCourseForm.absent_rule"
              :disabled="addCourseForm.package_type === 2"
            >
              <el-radio-button :label="1">扣</el-radio-button>
              <el-radio-button :label="0">不扣</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-tag type="warning" v-show="addCourseForm.package_type === 2"
            >时间课包扣课规则不可修改</el-tag
          >
        </el-form-item>
      </div>
      <div class="block">
        <p class="title">
          课程信息<span class="tips">自定义科目，需要自行编辑课程信息</span>
        </p>
        <p class="upload-tips">
          乐器图标支持jpeg、jpg、png格式，比例为1:1，每张图片小于1M<br />
          显示封面支持jpeg、jpg、png格式，比例为16:9，每张图片小于5M
        </p>
        <div class="course-info-wrap">
          <div class="left">
            <p class="desp"></p>
            <el-form-item label="乐器图标:">
              <image-uploader
                :originName.sync="addCourseForm.icon_image"
                :originUrl.sync="addCourseForm.icon_image_url"
                :sizeLimit="1"
                accept=".jpeg,.jpg,.png"
              >
                <div class="uploader1">
                  <img
                    v-if="addCourseForm.icon_image_url"
                    :src="addCourseForm.icon_image_url"
                    width="72"
                    height="72"
                  />
                </div>
              </image-uploader>
            </el-form-item>
            <el-form-item label="显示封面图标:">
              <image-uploader
                :originName.sync="addCourseForm.cover_image"
                :originUrl.sync="addCourseForm.cover_image_url"
                :sizeLimit="5"
                accept=".jpeg,.jpg,.png"
              >
                <div class="uploader2">
                  <img
                    v-if="addCourseForm.cover_image_url"
                    :src="addCourseForm.cover_image_url"
                    width="162"
                    height="92"
                  />
                </div>
              </image-uploader>
            </el-form-item>
          </div>
          <div class="right">
            <div class="desp">
              <richTextEditor :ori.sync="addCourseForm.detail"></richTextEditor>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-btns">
        <el-button class="mwow-button-filled" @click="$router.go(-1)"
          >取消</el-button
        >
        <el-button class="mwow-button-filled success" @click="handleSubmit"
          >保存</el-button
        >
      </div>
    </el-form>
  </div>
</template>
<script>
import { positivePass } from "@/utils/rules";
import {
  courseDetail,
  createCourse,
  editCourse,
  subjectDefaultInfo,
  getRelateCoursePackageSpecApi,
} from "@/api/course";
import { subjectList } from "@/api/subject";
import subjectDialog from "@/components/subjectDialog.vue";
import priceTable from "./priceTable.vue";
import richTextEditor from "@/components/richTextEditor.vue";
import imageUploader from "@/components/imageUploader.vue";
import colorSelector from "@/components/colorSelector.vue";
import { UserModule } from "@/store/module/user";
export default {
  components: {
    subjectDialog,
    priceTable,
    imageUploader,
    richTextEditor,
    colorSelector,
  },
  data() {
    return {
      allSubjectList: [],
      form_disabled: false,
      addCourseForm: {
        subject_id: "",
        course_name: "",
        course_type: 1,
        package_type: 1,
        absent_rule: 1,
        leave_rule: 1,
        leave_cycle: 0,
        leave_number: 0,
        icon_image: "",
        icon_image_url: "",
        cover_image: "",
        cover_image_url: "",
        detail: "",
        course_spec: [],
        color: "",
        sell_type: 1,
      },
      initData: {},
      rules: {
        subject_id: [
          { required: true, message: "请选择科目", trigger: "change" },
        ],
        course_name: [
          { required: true, message: "请输入课程名称", trigger: "blur" },
        ],
        course_type: [
          { required: true, message: "请选择课程类型", trigger: "change" },
        ],
        absent_rule: [],
        leave_rule: [{ required: true, message: "请选择", trigger: "change" }],
        leave_cycle: [],
        leave_number: [{ validator: positivePass, trigger: "blur" }],
        icon_image: [],
        icon_image_url: [],
        cover_image: [],
        cover_image_url: [],
        detail: [],
        course_spec: [],
        color: [
          { required: true, message: "请选择课程颜色", trigger: "change" },
        ],
      },
      coursePackageList: [],
    };
  },
  computed: {
    coursePackageSwitch() {
      return UserModule.userInfo.course_package_switch;
    },
  },
  created() {
    const id = Number(this.$route.query.id);
    if (this.$route.query.type) {
      this.form_disabled = this.$route.query.type === "1";
    }
    if (id !== 0) {
      // 编辑
      courseDetail({ course_id: id }).then((res) => {
        if (res.error_code === 0) {
          this.addCourseForm = {
            course_id: res.data.course_id,
            subject_id: res.data.subject_id,
            course_name: res.data.course_name,
            course_type: res.data.course_type,
            package_type: res.data.package_type,
            absent_rule: res.data.absent_rule,
            leave_rule: res.data.leave_rule,
            leave_cycle: res.data.leave_cycle,
            leave_number: res.data.leave_number,
            icon_image: res.data.icon_image,
            icon_image_url: res.data.icon_image_url,
            cover_image: res.data.cover_image,
            cover_image_url: res.data.cover_image_url,
            detail: res.data.detail,
            color: res.data.color,
            sell_type: res.data.sell_type,
          };
          this.getSubjectList();
          /*
          coursePackageList仅作展示
          创建课程时，调用getRelatePackage获取全部课包展示
          编辑课程时，如果是课包售卖，则使用res.data.course_spec填入；如果是自定义售卖，调用getRelatePackage获取全部课包展示
          addCourseForm.course_spec作为修改后的课程规格提交
          课包售卖时，course_spec不提交
          自定义售卖时，course_spec填入priceTable中的内容
          */
          if (res.data.sell_type === 2) {
            this.coursePackageList = res.data.course_spec.map((it) => {
              return {
                name: it.name,
                quantity: it.quantity,
                unit_price_1v1: it.unit_price,
                unit_price_1vn: it.unit_price,
                price_1v1: it.price,
                price_1vn: it.price,
              };
            });
            this.addCourseForm.course_spec = [];
          }
          if (res.data.sell_type === 1) {
            this.addCourseForm.course_spec = res.data.course_spec;
            this.getRelatePackage();
          }
        }
      });
    } else {
      // 创建课程时，获取关联全部课程课包规格
      this.getRelatePackage();
      this.getSubjectList();
    }
    subjectDefaultInfo().then((res) => {
      if (res.error_code === 0) {
        this.initData = res.data;
      }
    });
  },
  methods: {
    getRelatePackage() {
      getRelateCoursePackageSpecApi().then((res) => {
        this.coursePackageList = res.data.list;
      });
    },
    getSubjectList() {
      subjectList({
        page: 1,
        page_size: 500,
        status: 1,
      }).then((res) => {
        if (res.error_code === 0) {
          this.allSubjectList = res.data.list;
          // 设置课程信息
          const match = res.data.list.filter((item) => {
            return item.subject_id === this.addCourseForm.subject_id;
          });
          if (match[0] && match[0].preset_id !== 0) {
            this.addCourseForm.icon_image = match[0].preset.icon_image;
            this.addCourseForm.icon_image_url = match[0].preset.icon_image_url;
            this.addCourseForm.cover_image = match[0].preset.cover_image;
            this.addCourseForm.cover_image_url =
              match[0].preset.cover_image_url;
            this.addCourseForm.detail = match[0].preset.description;
          } else {
            this.addCourseForm.icon_image = "";
            this.addCourseForm.icon_image_url = this.initData.icon_image;
            this.addCourseForm.cover_image = "";
            this.addCourseForm.cover_image_url = this.initData.cover_image;
            this.addCourseForm.detail = "";
          }
        }
      });
    },
    handleSubmit() {
      this.$refs["mainForm"].validate((valid) => {
        if (valid) {
          const priceTable = this.$refs["priceTable"];
          const option = { ...this.addCourseForm };
          if (option.sell_type === 1) {
            const pass = this.checkPriceTable();
            if (pass) {
              const priceItems = priceTable.priceTableData;
              priceItems.map((item) => {
                item.quantity = String(item.quantity);
                item.price = String(item.price);
                item.unit_price = String(
                  Math.ceil((item.price / item.quantity) * 100) / 100
                );
              });
              option.course_spec = priceItems;
            }
          } else if (option.sell_type === 2) {
            delete option.course_spec;
          }
          // 发起请求
          delete option.cover_image_url;
          delete option.icon_image_url;
          if (this.$route.query.id === "0") {
            // 新增
            delete option.course_id;
            createCourse(option).then((res) => {
              if (res.error_code == 0) {
                this.$message({
                  type: "success",
                  message: "新增成功!",
                });
                this.$router.push({
                  name: "storeCourse",
                });
              } else {
                this.$message({
                  type: "error",
                  message: "新增失败!" + res.message,
                });
              }
            });
          } else {
            // 编辑
            editCourse(option).then((res) => {
              if (res.error_code == 0) {
                this.$message({
                  type: "success",
                  message: "编辑成功!",
                });
                this.$router.push({
                  name: "storeCourse",
                });
              } else {
                this.$message({
                  type: "error",
                  message: "编辑失败!" + res.message,
                });
              }
            });
          }
        }
      });
    },
    checkPriceTable() {
      const priceTable = this.$refs["priceTable"];
      if (!priceTable || priceTable.priceTableData.length === 0) {
        this.$message({
          type: "error",
          message: "请填写完整的课时定价信息",
        });
        return false;
      }
      let pass = true;
      let msg = "";
      priceTable.priceTableData.map((item) => {
        if (!item.name || !item.quantity || !item.price) {
          pass = false;
          msg = "请填写完整的课时定价信息";
        }
        if (item.quantity <= 0) {
          pass = false;
          msg = "课时数量有误";
        }
        if (item.price <= 0) {
          pass = false;
          msg = "课时总价有误";
        }
      });
      if (!pass) {
        this.$message({
          type: "error",
          message: msg,
        });
        return false;
      }
      return true;
    },
    handleSubjectChange(v) {
      const data = this.allSubjectList.filter((item) => {
        return item.subject_id === v;
      });
      if (data[0] && data[0].preset_id !== 0) {
        this.addCourseForm.icon_image = data[0].preset.icon_image;
        this.addCourseForm.icon_image_url = data[0].preset.icon_image_url;
        this.addCourseForm.cover_image = data[0].preset.cover_image;
        this.addCourseForm.cover_image_url = data[0].preset.cover_image_url;
        this.addCourseForm.detail = data[0].preset.description;
      } else {
        this.addCourseForm.icon_image = "";
        this.addCourseForm.icon_image_url = this.initData.icon_image;
        this.addCourseForm.cover_image = "";
        this.addCourseForm.cover_image_url = this.initData.cover_image;
        this.addCourseForm.detail = "";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  background-color: #ffffff;
  padding: 0 12px 12px 12px;
  border-radius: 4px;
}
.bottom-btns {
  text-align: left;
}
.block {
  margin: 20px 72px;
  border: 1px solid #d9dadb;
  border-radius: 4px;
  padding: 26px;
  .title {
    font-size: 14px;
    color: #5c5d5e;
    font-weight: bold;
    line-height: 14px;
    margin-bottom: 14px;
    .tips {
      font-size: 12px;
      color: #07d1aa;
      margin-left: 24px;
      font-weight: initial;
    }
  }
}
.leave-cost-wrap {
  margin-bottom: 12px;
  padding: 20px;
  background-color: #f6fafc;
  border-radius: 6px;
  display: inline-block;
  .tips {
    font-size: 12px;
    color: #07d1aa;
  }
  .text {
    margin: 0 8px;
    font-size: 12px;
    color: #5c5d5e;
  }
  /deep/.el-form-item {
    display: inline-block;
    width: 120px;
  }
}
.course-info-wrap {
  display: flex;
  .left {
    flex: 1;
    padding-right: 20px;
    border-right: 1px solid #e7e8ea;
    .desp {
    }
    .uploader1 {
      width: 70px;
      height: 70px;
      border: 1px solid #e7e8ea;
      border-radius: 6px;
    }
    .uploader2 {
      width: 160px;
      height: 90px;
      border: 1px solid #e7e8ea;
      border-radius: 6px;
    }
  }
  .right {
    flex: 1;
    padding-left: 20px;
    .desp {
      position: relative;
      z-index: 100;
    }
  }
}
.upload-tips {
  color: #9e9fa0;
  font-size: 12px;
  line-height: 24px;
  margin-bottom: 28px;
}
.course-package-wrap {
  margin: 0 0 24px 88px;
  .no-data {
    color: #5c5d5e;
    font-size: 12px;
  }
}
</style>
